var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"vod-icon",attrs:{"href":_vm.url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.fullUrl,"alt":`Часть ${_vm.ordinal+1}`,"title":`Часть ${_vm.ordinal+1}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }